// @flow
import * as React from 'react';
import Teaser from 'components/organisms/teaser/react/Teaser';
import type { TeaserType } from 'components/organisms/teaser/react/Teaser';
import Button from 'components/atoms/button/Button';
import { t } from 'javascripts/utils/withTranslation';

type Props = {
  items: Array<TeaserType>,
  loadMore: (event: SyntheticEvent<HTMLButtonElement>) => any,
  loading?: boolean,
};

export default function List(props: Props): React.MixedElement {
  const buttonConf: any = {};

  if (props.loading) {
    buttonConf.icon = 'list-loader';
  }

  return (
    <div className="list">
      <ul className="list__items">
        {props.items.map((item, index) => (
          <li key={index} className="list__item">
            <Teaser horizontal={true} border={true} {...item} />
          </li>
        ))}
      </ul>
      <div className="list__load">
        <Button onClick={props.loadMore} {...buttonConf}>
          {t('Mehr anzeigen')}
        </Button>
      </div>
    </div>
  );
}
